import { AXIS_TYPE, IChartAxisTypeSelectShower } from '@tencent/chart-drawer-components/lib/interface';
import ChartBaseDrawerFeature from '../chart-base-drawer-feature';
import { IChartModel } from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/chart-model.interface';
import { SLIDE_ADAPTER } from '@src/framework/workbench/editor-adpater/slide-adapter';
import { Feature } from '@tencent/workbench';

@Feature({
    name: 'ChartAxisTypeSelectShower',
    adapters: [SLIDE_ADAPTER],
    provide: IChartAxisTypeSelectShower,
})
export class ChartAxisTypeSelectShower extends ChartBaseDrawerFeature implements IChartAxisTypeSelectShower {
    public getCurrentAxisType() {
        return AXIS_TYPE.NONE;
    }

    public setCurrentAxisType(axisType: AXIS_TYPE): void {}

    public shouldHideSecondaryYAxis() {
        const model = this.getSelectModel() as IChartModel;
        if (!model.plotArea?.valueAxes?.length) return true;
        return !(model.plotArea?.valueAxes?.length > 1);
    }
}
